module.exports = __webpack_public_path__ + "static/media/trofeu_pink.93d990b9.svg";